<app-header></app-header>

<!-- Change domain / custom link popup (reuses success style) -->
<div class="success-popup-overlay" *ngIf="showDomainPopup">
    <div class="success-popup-content" (click)="$event.stopPropagation()">
        <button type="button" class="success-popup-corner-close" (click)="onCloseDomainPopup()" aria-label="Close popup">
            <i class="fas fa-times"></i>
        </button>
        <div class="success-popup-header">
            <div class="success-popup-icon-wrap">
                <i class="fas fa-globe success-popup-icon"></i>
            </div>
            <div class="success-popup-header-text">
                <h3 class="success-popup-title">Change domain / make custom link</h3>
                <p class="success-popup-subtitle">Update the tracking link domain or customise link parts.</p>
            </div>
        </div>
        <div class="success-popup-fields">
            <!-- Tracking Link -->
            <div class="success-popup-row success-popup-row-tracking">
                <span class="success-popup-label">
                    <i class="fas fa-link success-popup-label-icon"></i>
                    TRACKING LINK
                </span>
                <div class="success-popup-link-box">
                    <span class="success-popup-link-value" [title]="trackingUrl">{{ trackingUrl }}</span>
                    <button type="button" class="success-popup-copy-btn" (click)="onCopyTrackingLink()" [class.copied]="trackingUrlCopied" [attr.aria-label]="trackingUrlCopied ? 'Copied' : 'Copy tracking link'">
                        <i class="fas fa-copy" *ngIf="!trackingUrlCopied"></i>
                        <i class="fas fa-check" *ngIf="trackingUrlCopied"></i>
                        <span class="success-popup-copy-text">{{ trackingUrlCopied ? 'Copied!' : 'Copy' }}</span>
                    </button>
                </div>
            </div>
            <!-- Extra options: Domain, Extension, Path, Parameter -->
            <div class="success-popup-extra-options">
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label">Domain:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [value]="popupSelectedDomain || 'Select domain'"
                            readonly
                            [disabled]="domainsLoading || setDomainLoading"
                            [style.cursor]="(domainsLoading || setDomainLoading) ? 'not-allowed' : 'pointer'"
                            (click)="!(domainsLoading || setDomainLoading) && openCombo('domain')" />
                        <button type="button" class="success-popup-combo-btn" (click)="!(domainsLoading || setDomainLoading) && openCombo('domain')" [class.open]="openComboDropdown === 'domain'" aria-label="Open domain options" [disabled]="domainsLoading || setDomainLoading">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'domain'">
                            <button type="button" class="success-popup-combo-option" (click)="selectComboOption('domain', '')">
                                Select domain
                            </button>
                            <button type="button" class="success-popup-combo-option" *ngFor="let d of domainOptions" (click)="selectComboOption('domain', d)">
                                {{ d }}
                            </button>
                        </div>
                    </div>
                    <span class="success-popup-domain-loading" *ngIf="setDomainLoading"><i class="fas fa-spinner fa-spin"></i></span>
                </div>
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label success-popup-option-label-extension">Extension:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [(ngModel)]="popupSelectedExtension" (ngModelChange)="onPopupCustomizationInputChange()" placeholder="Select from the drop-down or enter in a custom extension" />
                        <button type="button" class="success-popup-combo-btn" (click)="openCombo('extension')" [class.open]="openComboDropdown === 'extension'" aria-label="Open extension options">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'extension'">
                            <button type="button" class="success-popup-combo-option" *ngFor="let opt of extensionOptions" (click)="selectComboOption('extension', opt)">
                                {{ opt }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label success-popup-option-label-path">Path:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [(ngModel)]="popupSelectedPath" (ngModelChange)="onPopupCustomizationInputChange()" placeholder="Select from the drop-down or enter in a custom path" />
                        <button type="button" class="success-popup-combo-btn" (click)="openCombo('path')" [class.open]="openComboDropdown === 'path'" aria-label="Open path options">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'path'">
                            <button type="button" class="success-popup-combo-option" *ngFor="let opt of pathOptions" (click)="selectComboOption('path', opt)">
                                {{ opt }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="success-popup-option-row">
                    <span class="success-popup-option-label success-popup-option-label-parameter">Parameter:</span>
                    <div class="success-popup-combo-wrap">
                        <input type="text" class="success-popup-combo-input" [(ngModel)]="popupSelectedParameter" (ngModelChange)="onPopupCustomizationInputChange()" placeholder="Select from the drop-down or enter in a custom parameter" />
                        <button type="button" class="success-popup-combo-btn" (click)="openCombo('parameter')" [class.open]="openComboDropdown === 'parameter'" aria-label="Open parameter options">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        <div class="success-popup-combo-dropdown" *ngIf="openComboDropdown === 'parameter'">
                            <button type="button" class="success-popup-combo-option" *ngFor="let opt of parameterOptions" (click)="selectComboOption('parameter', opt)">
                                {{ opt }}
                            </button>
                        </div>
                    </div>
                </div>
                <p class="success-popup-error" *ngIf="setDomainError">
                    <i class="fas fa-exclamation-circle"></i> {{ setDomainError }}
                </p>
                <p class="success-popup-loading" *ngIf="domainsLoading">
                    <i class="fas fa-spinner fa-spin"></i> Loading domains...
                </p>
            </div>
            <!-- Destination URL & Target Name (read-only) -->
            <div class="success-popup-row success-popup-row-kv">
                <div class="success-popup-kv-line">
                    <span class="success-popup-kv-keywrap">
                        <span class="success-popup-kv-key">Destination URL</span>
                        <span class="success-popup-kv-sep">:</span>
                    </span>
                    <span class="success-popup-kv-value" [title]="destinationUrl">{{ destinationUrl }}</span>
                </div>
                <div class="success-popup-kv-line">
                    <span class="success-popup-kv-keywrap">
                        <span class="success-popup-kv-key">Target Name</span>
                        <span class="success-popup-kv-sep">:</span>
                    </span>
                    <span class="success-popup-kv-value" [title]="targetName || ''">{{ targetName || '—' }}</span>
                </div>
            </div>
        </div>
        <div class="success-popup-buttons-row">
            <button type="button" class="success-popup-close-btn" (click)="onCloseDomainPopup()">
                <i class="fas fa-times success-popup-close-icon"></i>
                Close
            </button>
            <button type="button" class="success-popup-reset-btn" (click)="onResetDomainForm()" [disabled]="setDomainLoading">
                <i class="fas fa-undo success-popup-reset-icon" *ngIf="!setDomainLoading"></i>
                <i class="fas fa-spinner fa-spin success-popup-reset-icon" *ngIf="setDomainLoading"></i>
                Reset form
            </button>
        </div>
    </div>
</div>

<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid content-area px-2 px-sm-3 px-lg-4">
        <div class="result-inner">
            <!-- Top Header: Back, Analytics title + ID, destination URL, Export Data -->
            <div class="analytics-header">
                <div class="header-left">
                    <button type="button" class="back-button" (click)="onBackClick()">
                        <i class="fas fa-arrow-left back-icon"></i>
                        Back to Dashboard
                    </button>
                </div>
                <div class="header-center">
                    <h1 class="analytics-title">
                        <i class="fas fa-chart-bar analytics-title-icon"></i>
                        FasTrak: <span class="tracking-id">{{ alias || linkId }}</span>
                    </h1>
                </div>
                <!-- <div class="header-right">
                    <button type="button" class="export-data-btn" (click)="onExportData()">
                        <i class="fas fa-download export-icon"></i>
                        Export Data
                    </button>
                </div> -->
            </div>

            <!-- Analytics load error -->
            <div class="section-card error-card" *ngIf="analyticsError">
                <p class="error-message"><i class="fas fa-exclamation-circle"></i> {{ analyticsError }}</p>
                <button type="button" class="retry-btn" (click)="loadAnalytics()">Retry</button>
            </div>
            <!-- Summary Statistics -->
            <div class="stats-grid" *ngIf="!analyticsError">
                <div class="stat-card stat-card--clicks">
                    <span class="stat-icon-wrap" aria-hidden="true">
                        <i class="fas fa-chart-bar stat-icon"></i>
                    </span>
                    <div class="stat-content">
                        <span class="stat-value">{{ totalClicks }}</span>
                        <span class="stat-label">Total Clicks</span>
                    </div>
                </div>
                <div class="stat-card stat-card--visitors">
                    <span class="stat-icon-wrap" aria-hidden="true">
                        <i class="fas fa-users stat-icon"></i>
                    </span>
                    <div class="stat-content">
                        <span class="stat-value">{{ uniqueVisitors }}</span>
                        <span class="stat-label">Unique Visitors</span>
                    </div>
                </div>
                <div class="stat-card stat-card--countries">
                    <span class="stat-icon-wrap" aria-hidden="true">
                        <i class="fas fa-globe stat-icon"></i>
                    </span>
                    <div class="stat-content">
                        <span class="stat-value">{{ countriesCount }}</span>
                        <span class="stat-label">Countries</span>
                    </div>
                </div>
                <div class="stat-card stat-card--vpn">
                    <span class="stat-icon-wrap" aria-hidden="true">
                        <i class="fas fa-shield-alt stat-icon"></i>
                    </span>
                    <div class="stat-content">
                        <span class="stat-value">{{ vpnProxyCount }}</span>
                        <span class="stat-label">VPN/Proxy</span>
                    </div>
                </div>
            </div>

            <!-- Tracking Link Card -->
            <div class="section-card tracking-link-card highlighted-tracking-card" *ngIf="!analyticsError">
                <div class="section-title-row tracking-link-title-row">
                    <h2 class="section-title text-highlight">
                        <i class="fas fa-link section-icon text-highlight"></i>
                        Your Tracking Link
                    </h2>
                    <div class="destination-url-top-right" *ngIf="destinationUrl">
                        <span class="destination-url-heading">Redirects to:</span>
                        <span class="destination-link" [title]="destinationUrl">{{ destinationUrl }}</span>
                    </div>
                </div>
                <!-- <p class="section-desc">Share this link to track visitors. Copy the link or change the domain.</p> -->
                <div class="tracking-fields tracking-fields-highlighted">
                    <div class="field-group field-group-url">
                        <div class="url-input-row url-input-row-highlighted">
                            <div class="url-loading-wrap" [class.loading]="setDomainLoading">
                                <input type="text" class="field-input url-input url-input-highlighted" [value]="trackingUrl" readonly />
                                <span class="url-loading-spinner" *ngIf="setDomainLoading">
                                    <i class="fas fa-spinner fa-spin"></i>
                                </span>
                            </div>
                            <div class="highlighted-actions-group">
                                <button type="button" class="copy-btn copy-btn-highlighted" [class.copied]="trackingUrlCopied" (click)="onCopyTrackingLink()" [disabled]="setDomainLoading" [title]="trackingUrlCopied ? 'Copied' : 'Copy link'">
                                    <i class="fas fa-copy" *ngIf="!trackingUrlCopied"></i>
                                    <span class="copy-btn-text" *ngIf="trackingUrlCopied">Copied</span>
                                </button>
                                <button type="button" class="change-domain-btn change-domain-btn-highlighted" (click)="onOpenDomainPopup()" [disabled]="domainsLoading">
                                    <i class="fas fa-sliders-h"></i>
                                    Customize Link
                                </button>
                            </div>
                        </div>
                        <div class="short-url-block" *ngIf="shortRedirectUrl">
                            <label class="short-url-label">
                                <i class="fas fa-link short-url-label-icon"></i>
                                Short Redirect URL
                            </label>
                            <div class="url-input-row url-input-row-highlighted short-url-row">
                                <div class="url-loading-wrap">
                                    <input type="text" class="field-input url-input url-input-highlighted short-url-input" [value]="shortRedirectUrl" readonly />
                                </div>
                                <button type="button" class="copy-btn copy-btn-highlighted short-url-copy-btn" [class.copied]="shortRedirectUrlCopied" (click)="onCopyShortRedirectUrl()" [title]="shortRedirectUrlCopied ? 'Copied' : 'Copy short URL'">
                                    <i class="fas fa-copy" *ngIf="!shortRedirectUrlCopied"></i>
                                    <span class="copy-btn-text" *ngIf="shortRedirectUrlCopied">Copied</span>
                                </button>
                            </div>
                        </div>
                        <div class="tracking-qr-block" *ngIf="qrCodeDataUrl">
                            <label class="short-url-label">
                                <i class="fas fa-qrcode short-url-label-icon"></i>
                                QR Code
                            </label>
                            <div class="tracking-qr-wrap">
                                <div class="tracking-qr-actions tracking-qr-actions-top">
                                    <button type="button" class="tracking-qr-btn" (click)="onDownloadQrCode()">
                                        <i class="fas fa-download"></i>
                                        Download
                                    </button>
                                    <button type="button" class="tracking-qr-btn" (click)="onShareQrCode()">
                                        <i class="fas fa-share-alt"></i>
                                        Share
                                    </button>
                                </div>
                                <img class="tracking-qr-image" [src]="qrCodeDataUrl" alt="Tracking link QR code" />
                            </div>
                        </div>
                        <p class="field-error" *ngIf="setDomainError">{{ setDomainError }}</p>
                    </div>
                </div>
            </div>

            <!-- Recent Clicks Card -->
            <div class="section-card recent-clicks-card" *ngIf="!analyticsError">
                <div class="section-title-row">
                    <h2 class="section-title">
                        <i class="fas fa-clock section-icon"></i>
                        Visitor Interaction Details
                    </h2>
                    <div class="hide-bots-toggle">
                        <label class="toggle-switch">
                            <input type="checkbox" [(ngModel)]="hideBots" name="hideBots" />
                            <span class="toggle-slider"></span>
                        </label>
                        <span class="hide-bots-label">Hide Bots</span>
                    </div>
                </div>
                <p class="section-desc">Detailed information about each tracked click.</p>
                <div class="clicks-loading" *ngIf="analyticsLoading">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Loading analytics...</span>
                </div>
                <div class="clicks-table-wrapper" *ngIf="!analyticsLoading">
                    <table class="clicks-table">
                        <thead>
                            <tr>
                                <th>Timestamp (IST)</th>
                                <th>IP Address</th>
                                <th>Captured Details</th>
                                <th>Device</th>
                                <th>Resolution</th>
                                <th>Referrer</th>
                                <th>User Agent</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of filteredVisitorInteractions" [class.clickable-row]="!row.isPreviewFetch" (click)="!row.isPreviewFetch && onTimestampClick(row)" (keydown.enter)="!row.isPreviewFetch && onTimestampClick(row)" [attr.role]="row.isPreviewFetch ? null : 'button'" [attr.tabindex]="row.isPreviewFetch ? null : 0">
                                <td class="timestamp-cell">{{ row.timestamp }}</td>
                                <td class="ip-cell">
                                    <span class="ip-with-icon">
                                        <span class="ip-text">{{ row.ipAddress || '—' }}</span>
                                        <button type="button" class="bot-info-icon-btn" *ngIf="row.is_bot" (click)="onBotInfoClick(row, $event)" aria-label="View bot info" title="View bot info">
                                            <i class="fas fa-info-circle bot-info-icon"></i>
                                        </button>
                                    </span>
                                </td>
                                <td>
                                    <div class="location-pills">
                                        <span class="pill pill-gps" *ngIf="row.hasGps">
                                            <i class="fas fa-map-marker-alt"></i> GPS
                                        </span>
                                        <span class="pill pill-photos" *ngIf="row.photosCount">
                                            <i class="fas fa-camera"></i> {{ row.photosCount }} Photos
                                        </span>
                                        <span class="pill pill-screen" *ngIf="row.hasScreenshot">
                                            <i class="fas fa-desktop"></i> Screen
                                        </span>
                                        <span class="pill pill-none" *ngIf="!row.hasGps && !row.photosCount && !row.hasScreenshot">—</span>
                                    </div>
                                </td>
                                <td>{{ row.device || '—' }}</td>
                                <td>{{ row.resolution || '—' }}</td>
                                <td class="referrer-cell">{{ row.referrer || '—' }}</td>
                                <td class="user-agent-cell" [title]="row.userAgent || ''">{{ row.userAgent || '—' }}</td>
                            </tr>
                            <tr *ngIf="filteredVisitorInteractions.length === 0">
                                <td colspan="7" class="empty-state">No visitor interactions recorded yet.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Date Range Filter -->
            <!-- <div class="section-card date-filter-card" *ngIf="!analyticsError">
                <h2 class="section-title">
                    <i class="fas fa-calendar-alt section-icon"></i>
                    Date Range Filter
                </h2>
                <div class="date-filter-row">
                    <div class="field-group">
                        <label class="field-label">From Date</label>
                        <div class="date-input-wrap">
                            <input type="text" class="field-input date-input" [(ngModel)]="fromDate" placeholder="dd-mm-yyyy" />
                            <i class="fas fa-calendar-alt date-picker-icon"></i>
                        </div>
                    </div>
                    <div class="field-group">
                        <label class="field-label">To Date</label>
                        <div class="date-input-wrap">
                            <input type="text" class="field-input date-input" [(ngModel)]="toDate" placeholder="dd-mm-yyyy" />
                            <i class="fas fa-calendar-alt date-picker-icon"></i>
                        </div>
                    </div>
                    <button type="button" class="clear-filter-btn" (click)="onClearDateFilter()">Clear Filter</button>
                </div>
            </div> -->



            <!-- Browser & OS Distribution -->
            <div class="distribution-row" *ngIf="!analyticsError">
                <div class="section-card distribution-card">
                    <h2 class="section-title">
                        <i class="fas fa-window-maximize section-icon"></i>
                        Browser Distribution
                    </h2>
                    <div class="chart-bars">
                        <div class="chart-bar-item" *ngFor="let b of browserDistribution">
                            <span class="chart-value">{{ b.value }}</span>
                            <div class="chart-bar-wrap">
                                <div class="chart-bar chart-bar-purple" [style.width.%]="b.percent"></div>
                            </div>
                            <span class="chart-label">{{ b.label }}</span>
                        </div>
                    </div>
                </div>
                <div class="section-card distribution-card">
                    <h2 class="section-title">
                        <i class="fas fa-desktop section-icon"></i>
                        Operating System Distribution
                    </h2>
                    <div class="chart-bars">
                        <div class="chart-bar-item" *ngFor="let o of osDistribution">
                            <span class="chart-value">{{ o.value }}</span>
                            <div class="chart-bar-wrap">
                                <div class="chart-bar chart-bar-cyan" [style.width.%]="o.percent"></div>
                            </div>
                            <span class="chart-label">{{ o.label }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Geographic Distribution -->
            <div class="section-card geo-card" *ngIf="!analyticsError">
                <h2 class="section-title">
                    <i class="fas fa-globe-americas section-icon"></i>
                    Geographic Distribution
                </h2>
                <div class="geo-content">
                    <div class="visitor-map">
                        <div class="geo-subtitle-row">
                            <h3 class="geo-subtitle">Visitor Travel Map</h3>
                            <div class="route-switcher" *ngIf="userRoutes.length > 0">
                                <button type="button" class="route-switch-btn" [class.active]="selectedRouteId === 'all'" (click)="onSelectRoute('all')">
                                    All Users
                                </button>
                                <button type="button" class="route-switch-btn" *ngFor="let route of userRoutes" [class.active]="selectedRouteId === route.id" (click)="onSelectRoute(route.id)">
                                    <span class="route-color-dot" [style.background]="route.color"></span>
                                    {{ route.label }}
                                </button>
                            </div>
                        </div>
                        <div class="map-placeholder">
                            <div class="map-header">
                                <span class="map-gps-label"><i class="fas fa-map-marker-alt map-dot map-dot-gps"></i> {{ mapGpsCount }} GPS</span>
                                <span class="map-ip-label" *ngIf="mapIpCount > 0"><i class="fas fa-globe map-dot map-dot-ip"></i> {{ mapIpCount }} IP</span>
                            </div>
                            <div #mapContainer class="map-canvas map-canvas-leaflet"></div>
                            <div class="map-footer">
                                <span>{{ totalClicks }} Visitors</span>
                                <span>from {{ countriesCount }} countries</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Case Reference Notes -->
            <div class="section-card notes-card" *ngIf="!analyticsError">
                <h2 class="section-title">
                    <i class="fas fa-file-alt section-icon"></i>
                    Case Reference Notes
                </h2>
                <div class="notes-loading" *ngIf="notesLoading">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Loading notes...</span>
                </div>
                <textarea class="notes-textarea" [(ngModel)]="caseNotes" placeholder="Add case notes or reference numbers..." rows="4" [disabled]="notesLoading" *ngIf="!notesLoading"></textarea>
                <p class="notes-error" *ngIf="notesError">
                    <i class="fas fa-exclamation-circle"></i> {{ notesError }}
                </p>
                <p class="notes-success" *ngIf="notesSuccess">
                    <i class="fas fa-check-circle"></i> {{ notesSuccess }}
                </p>
                <div class="notes-actions">
                    <button type="button" class="save-notes-btn" (click)="onSaveNotes()" [disabled]="notesSaving || notesLoading">
                        <i class="fas fa-spinner fa-spin" *ngIf="notesSaving"></i>
                        <i class="fas fa-save" *ngIf="!notesSaving"></i>
                        {{ notesSaving ? 'Saving...' : 'Save' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
